import { createThemeCompiler } from '../../../utils';

export const sliderThemeCompiler = createThemeCompiler(({ palette, borderRadius, gap }) => ({
    slider: {
        colors: {
            default: {
                knob: {
                    backgroundColor: palette.themePrimary
                },
                slideArea: {
                    emptyAreaBackground: '#E9E8E9',
                    filledAreaBackground: palette.themePrimary
                }
            },
            disabled: {
                knob: {
                    backgroundColor: palette.themeSecondary
                },
                slideArea: {
                    emptyAreaBackground: '#E9E8E9',
                    filledAreaBackground: palette.themePrimary
                }
            }
        },
        composites: {
            knob: {
                borderRadius: borderRadius.circle,
                thickness: gap.l
            },
            slideArea: {
                borderRadius: borderRadius.curvedXLarge,
                thickness: gap.m
            },
            gap: '6px'
        }
    }
}));
